// extracted by mini-css-extract-plugin
export default {"root":"Header_root__zLrI3","heading":"Header_heading__xOk1k"};